'use strict';
var ibmStickyFooter = (function () {
    function ibmStickyFooter($window) {
        this.$window = $window;
        this.restrict = 'A';
    }
    ibmStickyFooter.prototype.link = function (scope, element, iAttrs) {
        var stickyFooterWrapper = $(iAttrs.stickyFooter);
        stickyFooterWrapper.parents().css('height', '100%');
        stickyFooterWrapper.css({
            'min-height': '100%',
            'height': 'auto'
        });
        // Append a pushing div to the stickyFooterWrapper.
        var stickyFooterPush = $('<div class="push"></div>');
        stickyFooterWrapper.append(stickyFooterPush);
        var setHeights = function () {
            var height = element.outerHeight();
            stickyFooterPush.height(height);
            stickyFooterWrapper.css('margin-bottom', -(height));
        };
        $(window).on('resize', setHeights);
    };
    ibmStickyFooter.factory = function () {
        var directive = function ($window) { return new ibmStickyFooter($window); };
        directive.$inject = ['$window'];
        return directive;
    };
    return ibmStickyFooter;
}());
angular
    .module('application')
    .directive('ibmStickyFooter', function () { return ibmStickyFooter.factory(); });

//# sourceMappingURL=ibm-sticky-footer.js.map
